<template>
    <div v-show="isShow" :style="domStyle">
    <audio ref="audio" loop="loop"></audio>
        <div v-if="isRefresh">
            <span class="header" ref="mycolor">
                <Table size="small" :height="tableHeight" @on-row-dblclick="onConfirmAlarm" :columns="alarmmReport" :data="alarmData" :row-class-name="rowClassName"></Table>
                <Page :total="dataCount" :page-size="pageSize" size="small" class="paging" @on-change="changepage"></Page>
                
            </span>
        </div>
        <Modal v-model="alarmModal" title="确认报警" @on-ok="confirmAlarmMsg" @on-cancel="unConfirmAlarmMsg">
            <Card class="clearfix" :dis-hover="true" :bordered="false">
                <Form v-for="item in this.alarmForm" :key="item.key"  label-position="right" :label-width="70">
                    <FormItem :label="item.title" style="margin-bottom:5px;float:left;">
                        <Input v-if="item.key != 'relieveAlarmReason'" style="width:150px;" :readonly="true" v-model="singleAlarmData[item.key]"></Input>
                        <Input v-else  :autosize="{minRows: 2,maxRows: 3}" style="width:370px;" v-model="singleAlarmData[item.key]" placeholder="请输入解除报警的原因..."> 
                            <Button @click="showCause" slot="append">历史报警</Button>
                        </Input>
                    </FormItem>
                </Form>
            </Card>
        </Modal>
        <Modal v-model="allAlarmModal" title="确认全部报警" @on-ok="confirmAllAlarmMsg" @on-cancel="unConfirmAllAlarmMsg">
            <Input v-model="allAlarmInfo" type="textarea" :autosize="{minRows: 2,maxRows: 3}" placeholder="输入全部确认报警的原因..." />
        </Modal>
        <Modal v-model="isShowHistoryCause" title="历史原因列表" >
            <Table size="small" :height="tableHeight" :columns="alarmmReports" :data="alarmDatas"></Table>
        </Modal>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<style>
    .header {
        --oddColor: "";
        --evenColor: "";
        --fontColor: "";
        --alarmColor: "";
        --tableColor : "";
        
    }
    .header .ivu-table{
        background-color:var(--tableColor);
    }
    .header .ivu-page-next{
        background-color:var(--tableColor);
    }
    .header .ivu-page-prev{
        background-color:var(--tableColor);
    }
    .header .ivu-page-item{
        background-color:var(--tableColor);
    }
    .paging{
        float:right;
        margin-top:5px;
        white-space: nowrap;
        display:flex;
    }
    .clearfix:before,.clearfix:after {  
        content:"";  
        display:table;  
    }  
    /*用于清除浮动*/ 
    .clearfix:after{  
        clear:both;  
    }  
    .clearfix{  
        *zoom:1;/*IE/7/6*/ 
    }
    .center-table-info-row .twinkleList{
        -webkit-animation: twinkling 2s infinite;
    }
    @-webkit-keyframes twinkling{
        0%{
            border:2px solid #f00;
            border-left: 0px;
            border-right: 0px;
        }
    }
    /* 奇数 */
    .center-table-info-row td{
        background-color: var(--oddColor);
        color: var(--fontColor);
    }
    /* 偶数 */
    .center-table-error-row td{
        background-color: var(--evenColor);
        color: var(--fontColor);
    }

    .center-table-alarm-row td{
        background-color: var(--alarmColor);
        color: var(--fontColor);
    }
    /* 表头 */
    .header .ivu-table-wrapper .ivu-table-header{
        color: var(--fontColor);
    }
</style>
<script>
import Print from 'print-js'
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        this.defaultTailoring = this.parentObject.defaultTailoring;
        this.windowSize = this.parentObject.windowSize;
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        };
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        };
        this.decimal = this.decimal ? this.decimal:0;
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        if(this.alarmType != 1){
            this.updateData();
        };
    },
    mounted(){
        
    },
    data(){
        return {
            isShowHistoryCause : false,

            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            alarmmReport : [],
            alarmmReports : [ {
                title: '时间',
                key: 'time'
            },
            {
                title: '确认人',
                key: 'user'
            },
            {
                title: '原因',
                key: 'reason'
            }],
            //历史原因数据
            alarmDatas : [],
            alarmData : [],
            alarmModal : false, //确认报警弹窗
            singleAlarmData : {},
            allAlarmModal : false,  //确认全部报警弹窗
            allAlarmInfo : "",      //确认全部报警的解除原因
            tableHeight : 0,
            pageSize : 5,
            currentPage : 1 ,          // 当前页数
            dataCount:0,        // 总条数
            isRefresh : true,
            alarmForm : [],
            alarmType : 0,
            twinkleList : [],
            isSilence : false,
            isStartAudio : false,
            tableColorShow: false
        }
    },
    methods:{
        // 奇偶行
        rowClassName (row, index) {
            // 奇偶行检测
            if(this.tableColorShow){
                // 查询报警数据
                let data = this.twinkleList.find((item) => {
                    return item == row._id
                });
                if(data){
                    return 'center-table-alarm-row';
                }else{
                    if(index % 2){
                        return 'center-table-info-row';
                    }else if((index % 2) == 0){
                        return 'center-table-error-row';
                    };
                }
            }else{
                if(index % 2){
                    return 'center-table-info-row';
                }else if((index % 2) == 0){
                    return 'center-table-error-row';
                };
            };

        },
        setColor() {
            var n = 0;
            this.isTransparent ? n = 0.2 : n = 1; 
            
            this.$refs.mycolor.style.setProperty("--oddColor", this.colorRgba(this.oddColor, 1));
            this.$refs.mycolor.style.setProperty("--evenColor", this.colorRgba(this.evenColor, 1));
            this.$refs.mycolor.style.setProperty("--alarmColor", this.colorRgba("#ff0000", 1));
            this.$refs.mycolor.style.setProperty("--fontColor", this.colorRgba(this.fontColor, 1));
            
            this.$refs.mycolor.style.setProperty("--tableColor",this.isTransparent ? "transparent" : "#f8f8f9");
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            this.setColor();
            if(this.isEnable) return;
            //如果不是实时报警，就不进行循环查询调用
            if(this.alarmType != 1) return;
            var curTime = new Date().getTime();
            if(curTime - this.lastTime < this.stepTime) return;
            this.lastTime = curTime;
            this.updateData();
    

            // 是否显示实时报价闪烁
            if(this.twinkle){
                // 1秒提醒一次预警颜色
                if(this.tableColorShow){
                    this.tableColorShow = false;
                }else{
                    this.tableColorShow = true;
                };
            }else{
                this.tableColorShow = false;
            };
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.domStyle.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + scaleObj.titleHeight + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height =  parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.realWidth = parseInt(this.width * (scaleObj.sx + scaleObj.zoom));
            this.tableHeight = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) - 29;
            this.updateColumn();
            this.isRefresh = false;
            this.$nextTick(() => {
                this.isRefresh = true;
            })
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：state 0：不启用，1：启用
            作用：设置报警声音是否启用
        */
        EnableAudio(state){
            if(state == 0){
                this.alarmAudio = 0;
            }else if(state == 1){
                this.alarmAudio = 1;
            }else{
                this.$Message.warning(this.$store.state.system.$.languageName == "ch" ?"参数设定有误！":"Incorrect parameter setting")
            }
        },
        /*
            参数：无
            作用：打印报警中心报表
        */
        Print(){
             if(this.nav()){
                this.$Message.warning("手机以及ipad不支持表单打印!")
            }else{
                this.$Spin.show();
                var columnName = [];
                for(var k in this.jsonData[0]){
                    columnName.push(k);
                }
                Print({
                    printable : this.jsonData,
                    properties : columnName,
                    type: 'json',
                        onLoadingEnd: () => {
                        this.$Spin.hide();
                    }
                })
            }
        },
        /*
            参数：alarmLevel:报警级别
                 modelType:模型类型
                 relieve:是否解除报警
                 companyName:公司名称
                 modelName:模型名称
                 ruleName:规则名称
                 startTime:开始时间
                 endTime:结束时间
                 relieveAlarmUser:报警解除人
                 relieveStartTime:解除报警时间
                 relieveEndTime:解除报警时间
            作用：查询条件
        */
        SetAlarmQuality(alarmLevel,modelType,relieve,companyName,modelName,ruleName,startTime,endTime,relieveAlarmUser,relieveStartTime,relieveEndTime){
            this.$Notice.open({
                title: 'SetAlarmQuality脚本已经废弃',
                desc: `请调用
                SetFilterTime,SetFilterType,SetFilterUserName,
                SetFilterLevel,SetFilterCompanyName,SetFilterModelName,
                SetFilterRelieve,SetFilterRelieveTime,SetFilterRuleName,
                SetFilterRUser这些脚本`,
                duration: 0
            });
        },
        /*
            参数： companyName 公司名称
            作用： 设置报警请求报警时"公司名称"字段的过滤条件
        */
        SetFilterCompanyName(companyName){
            this.companyName = companyName;
        },
        /*
            参数： alarmLevel:字符串
            作用：设置报警请求报警时"报警等级"字段的过滤条件
        */
        SetFilterLevel(alarmLevel){
            this.alarmLevel = alarmLevel;
        },
        /*
            参数：modelName:模型名称
            作用：设置报警请求报警时"模型名称"字段的过滤条件
        */
        SetFilterModelName(modelName){
            this.modelName = modelName;
        },
        /*
            参数：relieve:是否确认报警 1：是 0：否
            作用：设置报警请求报警时"是否确认"字段的过滤条件
        */
        SetFilterRelieve(relieve){
            this.relieve = relieve;
        },
        /*
            参数：startTime:开始时间，endTime结束时间
            作用：设置报警请求报警确认时间在时间范围内
        */
        SetFilterRelieveTime(startTime,endTime){
            this.relieveStartTime = startTime.split(".").join("-");
            this.relieveEndTime = endTime.split(".").join("-");
        },
        /*
            参数：modelName:规则名称
            作用：设置报警请求报警时"规则名称"字段的过滤条件（包含指定字符）
        */
        SetFilterRuleName(modelName){
            this.ruleName = modelName;
        },
        /*
            参数：user:确认人
            作用：设置报警请求报警时"确认人"字段的过滤条件
        */
        SetFilterRUser(user){
            this.relieveAlarmUser = user;
        },
        /*
            参数：startTime：开始时间，endTime：结束时间
            作用：设置报警请求报警产生时间在时间范围内
        */
        SetFilterTime(startTime,endTime){
            if(this.alarmType == 1){
                this.$Message.warning(this.$store.state.system.$.languageName == "ch" ?"实时报警不能通过时间筛选":"Real-time alarm cannot pass time filtering");
                return;
            }
            this.startTime = startTime;
            this.endTime = endTime;
        },
        /*
            参数：modelType:报警类型，0：历史 1：实时 2：消除报警
            作用：设置报警请求报警时"报警类型"字段的过滤条件
        */
        SetFilterType(modelType){
            this.alarmType = modelType;
            this.ruleName = undefined ;
            this.modelName = undefined ;
            this.relieveStartTime = undefined ;
            this.relieveEndTime = undefined ;
            this.relieveAlarmUser = undefined ;
            this.startTime = undefined ;
            this.endTime = undefined ;
            this.userName = undefined ;
        },
        /*
            参数：user:负责人
            作用：设置报警请求报警时"负责人"字段的过滤条件
        */
        SetFilterUserName(user){
            this.userName = user;
        },
        /*
            参数：value 间隔时间
            作用：设置查询数据的时间间隔
        */
        SetStepTime(value){
            this.stepTime = value;
        },
        /*
            参数：无
            作用：确认全部报警
        */
        ConfirmAlarm(){
            if(this.alarmType == 1){
                if(this.alarmData.length > 0 ){
                    this.allAlarmModal = true;
                }
            }else{
                this.$Message.warning(this.$store.state.system.$.languageName == "ch" ?"历史报警无法进行确认！":"History alarm cannot be confirmed!");
            }
        },
        //脚本函数，历史报警时设置完条件后刷新数据
        UpDateData(){
            
            this.updateData();
        },
        CleanFilter(){
            this.ruleName = undefined;
            this.modelName = undefined;
            this.relieveStartTime = undefined;
            this.relieveEndTime = undefined;
            this.relieveAlarmUser = undefined;
            this.startTime = undefined;
            this.endTime = undefined;
            this.userName = undefined;
            this.alarmLevel= undefined;
            this.modelType = undefined;
            this.relieve = undefined;
        },
        /*-------------------------------------------脚本在上-------------------------------------------------*/
        /*-------------------------------------------方法在下-------------------------------------------------*/
        
        /*
            参数：无
            作用：更新表单数据
        */
        updateData(){
            //恢复第一页
            this.changepage(1);
            if(this.alarmType == 0 || this.alarmType == 2){
                if(this.startTime == ""|| this.startTime == undefined){
                    this.$Message.warning(this.$store.state.system.$.languageName == "ch" ?"类型历史或清除报警开始时间不能为空！":"Type history or clear alarm start time cannot be empty!");
                    return;
                }
                if(this.endTime == ""|| this.endTime == undefined){
                    this.$Message.warning(this.$store.state.system.$.languageName == "ch" ?"类型历史或清除报警结束时间不能为空！":"The type history or clear alarm end time cannot be empty!");
                    return;
                }
            }
            var obj = this.createHead( {
                "head" : "getAlarmData",
                "message" : {
                    "alarmType"  : this.alarmType,
                    "searchData" : {
                        "limitCount" :this.limitCount,
                        "ruleName"         : this.ruleName == "" ? undefined : this.ruleName,
                        "modelName"        : this.modelName == "" ? undefined : this.modelName,
                        "relieveStartTime" : this.relieveStartTime == "" ? undefined : this.relieveStartTime,
                        "relieveEndTime"   : this.relieveEndTime == "" ? undefined : this.relieveEndTime,
                        "confirmInfo.user" : this.relieveAlarmUser == "" ? undefined : this.relieveAlarmUser,
                        "startTime"        : this.startTime == "" ? undefined : this.startTime,
                        "endTime"          : this.endTime == "" ? undefined : this.endTime,
                        "userName"         : this.userName == "" ? undefined : this.userName,
                        "ruleLevel"        : this.alarmLevel,
                        "modelType"        : this.modelType,
                        "confirmFlag"      : this.relieve
                    }
                }
            })

            this.fvSystemApi.getAlarmData(obj)
            .then((result) => {
                // 设置报警声音
                this.twinkleList = [];
                result.forEach((item,i)=>{
                    if(item.endTime == 0){
                        this.twinkleList.push(item._id);
                    }
                });
                if(this.twinkleList.length > 0){
                    this.$Modal.props.zIndex.default = this.$Modal.props.zIndex.default+20;
                    this.openAudio();
                }else{
                    if(!this.$refs.audio.paused)
                        this.$refs.audio.pause();
                }
                this.disposeData(result);
            })
            .catch((error) => {
                console.log(error);
            })
        },
        /*
            参数：无
            作用：更新表头数据
        */
        updateColumn(){
            var nIndex = -1;
            this.layout.forEach((item, index) => {
                if(item.key == "startTime"){
                    nIndex = index;
                }
                if(item.key == "tags"){
                    item.key = "tagDatas";
                }
                item["tooltip"] = true;
                item["align"] = "center";
                item["title"] = this.fvSystemApi.getResource(item.title) || item.title;
            });
            if(nIndex > 0){
                var item = this.layout.splice(nIndex,1);
                this.layout.unshift(item[0]);
            }
            this.alarmForm = JSON.parse(JSON.stringify(this.layout));
            this.alarmmReport =  this.layout;
            var tableWidth = 0;
            this.alarmmReport.forEach((el) =>{
                tableWidth += Number(el.width); 
            })
            // if(tableWidth < this.realWidth){
            //     this.alarmmReport.forEach((el) => {
            //         delete el.width;
            //     })
            // }
            // 表单数据排序如果存在解除原因字段则令其为最后一个字段
            var addState = false;
            for(var i = 0 ; i < this.alarmForm.length ; i++){
                if(this.alarmForm[i].key == "relieveAlarmReason"){
                    var obj = this.alarmForm[i];
                    this.alarmForm.splice(i,1);
                    addState = true;
                }
            }
            if(addState){
                this.alarmForm.push(obj);
            }
            // 防止用户选择表头中没有解除原因，从而双击确认报警时没办法填写解除原因的问题
            var columnList = [];
            this.alarmForm.forEach((lists) => {
                columnList.push(lists.key);
            })
            if(!~columnList.findIndex(element => element === 'relieveAlarmReason')){
                this.alarmForm.push({title : "解除原因",key : "relieveAlarmReason"})
            }
        },
        /*
            参数：data 需要处理的数据
            作用：将数据转换为展示数据
        */
        disposeData(data){
            if(data.length > 0 ){
                data.forEach((item) => {
                    if(typeof(item.tags) == "object"){
                        var tagList = [];
                        item.tags.forEach((list) => {
                            tagList.push(list.NAME);
                        })
                        item.tagDatas = tagList.join('&');
                    }
                    item.startTime = new Date(item.startTime).format("yyyy/MM/dd hh:mm:ss");
                    item.alarmType = this.parsingAlarmType(item.curData);
                    if(item.confirmInfo){
                        item.relieveAlarmUser = item.confirmInfo.user == "?" ? undefined : item.confirmInfo.user;
                        item.relieveAlarmTime = item.confirmInfo.time == "?" ? undefined : new Date(item.confirmInfo.time).format("yyyy/MM/dd hh:mm:ss");
                        item.relieveAlarmReason = item.confirmInfo.reason == "?" ? undefined : item.confirmInfo.reason;
                    }else{
                        item.relieveAlarmUser = "";
                        item.relieveAlarmTime = "";
                        item.relieveAlarmReason ="";
                    }
                   
                    //if(typeof(item.curData.alarmValue) == "number"){
                        item.alarmValue = Math.floor(parseFloat(item.curData.alarmValue) * Math.pow(10,this.decimal)) / Math.pow(10,this.decimal);
                    //}
                })
            }
            this.temporaryData = data;
            var page = Math.floor((this.tableHeight - 31.89)/40)
            this.pageSize = page > 1 ? page : 1; 
            this.changepage(this.currentPage);
        },
        /*
            参数：data 需要刷新的数据
            作用：刷新数据至表单
        */
        refreshTable(data){
            this.alarmData = data;
            this.jsonData = JSON.parse(JSON.stringify(data));
            this.disposePrintData(this.jsonData);
        },
        /**
         * 参数：isSilence 取消静音(0)/静音(1)
         * 作用：报警生意静音
         */
        Silence(isSilence){
            this.isSilence = isSilence;
            if(this.isSilence && !this.$refs.audio.paused){
                this.$refs.audio.pause();
            }else if(!this.isSilence && this.twinkleList.length > 0){
                this.$refs.audio.play();
            }
        },
        /*
            参数：data 数据
            作用：是否开启声音
        */
        openAudio(){
            if(this.isEnable || !this.isShow){
                if(!this.$refs.audio.paused)
                    this.$refs.audio.pause();
                return;
            }
            if(this.alarmAudio == 1){
                if(this.audioName != ""){
                    if(!this.$refs.audio.src){
                        this.$refs.audio.src = debugFWebView + this.$store.state.system.$.projectName+"/Audio/"+this.audioName;
                    }
                    if(!this.isSilence && this.$refs.audio.paused && !this.isStartAudio){
                            if(navigator.userAgent.indexOf('Chrome') > -1){
                           var timers=null;
                           clearTimeout(timers);
                           timers=setTimeout(()=>{
                            this.$Modal.confirm({
                                title: '系统',
                                content: '<p>谷歌浏览器需要主动开启声音</p>',
                                onOk: () => {
                                    this.isStartAudio = true;
                                    this.$refs.audio.play();
                                }
                            });
                           
                           },100)
                           
                        }else{
                            this.isStartAudio = true;
                            this.$refs.audio.play();
                        }
                        this.$Modal.props.zIndex.default = this.$Modal.props.zIndex.default+10
                   
                        
                    }else if(this.isStartAudio && !this.isSilence){
                        //this.$refs.audio.play();
                    }
                   
                    
                        
                }else{
                    this.$Message.warning(this.$store.state.system.$.languageName == "ch" ?"请设置报警声音!":"Please set the alarm sound!");
                }
            }
        },
        /*
            参数：data 报警类型缩写
            作用：将缩写的报警类型解析完整
        */
        parsingAlarmType(data){
            var alarmType = "";
            switch(data.alarmType){
                case "HH":
                    alarmType = "越高高限:" + data.limitValue;
                break;
                case "HI":
                    alarmType = "越高限:" + data.limitValue;
                break;
                case "LO":
                    alarmType = "越低限:" + data.limitValue;
                break;
                case "LL":
                    alarmType = "越低低限:" + data.limitValue;
                break;
                case "UP":
                    alarmType = "上升趋势";
                break;
                case "DOWN":
                    alarmType = "下降趋势";
                break;
                case "CES":
                    alarmType = "趋势无变化";
                break;
                case "continuty":
                    alarmType = "连续" + data.evaluateConut + "次超幅度报警";
                break;
                case "invalid":
                    alarmType = "缺陷报警";
                break;
                case "REAL":
                    alarmType = "自控实时";
                break;
                default:
                    alarmType = "错误的报警类型";
                break;
            }
            return alarmType;
        },
        /*
            参数：row 当前行数据，index 数据下标
            作用：双击确认报警
        */
        onConfirmAlarm(row,index){
            this.singleAlarmData = {};
            if(this.alarmType == 1){
                if(row.confirmFlag == 0){
                    row.relieveAlarmUser = this.$store.state.system.$.UserMessage.userName
                    row.relieveAlarmTime = new Date().format("yyyy/MM/dd hh:mm:ss");
                    this.singleAlarmData = row;
                    this.alarmModal = true;
                    //获取确认原因
                    this.getHistoryCause(this.singleAlarmData)
                    
                }else{
                    this.$Message.warning(this.$store.state.system.$.languageName == "ch" ?"该报警已经确认！":'The alarm has been confirmed!')
                }
            }else{
                this.$Message.warning(this.$store.state.system.$.languageName == "ch" ?"历史报警无法进行确认！":"History alarm cannot be confirmed!");
            }
        },
        /*
            参数：无
            作用：确认报警信息
        */
        confirmAlarmMsg(){
            if(this.singleAlarmData.relieveAlarmReason != null){
                var data = this.createHead({
                    "head" : "makeConfirmAlarm",
                    "message" : {
                        "confirmList" : [this.singleAlarmData._id],
                        "confirmAlarmInformation" : {
                            "confirmFlag":1,
                            "relieveAlarmReason":this.singleAlarmData.relieveAlarmReason,
                            "relieveAlarmUser":this.singleAlarmData.relieveAlarmUser,
                            "relieveAlarmTime":new Date(this.singleAlarmData.relieveAlarmTime).getTime()
                        }
                    }
                })
                    
                this.fvSystemApi.getAlarmData(data,(result,error) => {
                    if(error){
                        // console.log(error);
                        this.$Message.error("确认报警失败")
                    }else{
                        this.updateData();
                    }
                })
            }else{
                this.$Message.error("解除原因不能为空！");
            }
        },
        /*
            参数：无
            作用：取消确认报警信息
        */
        unConfirmAlarmMsg(){},
        /*
            参数：无
            作用：确认全部报警信息
        */
        confirmAllAlarmMsg(){
            if(this.allAlarmInfo != null){
                var confirmAlarmIdList = [];
                // 获取未确认的报警的id
                this.alarmData.forEach((item) => {
                    if(item.confirmFlag != 0) return;
                    confirmAlarmIdList.push(item._id);
                })
                var data = this.createHead({
                    "head" : "makeConfirmAlarm",
                    "message" : {
                        "confirmList" : confirmAlarmIdList,
                        "confirmAlarmInformation" : {
                            "confirmFlag":1,
                            "relieveAlarmReason":this.allAlarmInfo,
                            "relieveAlarmUser":this.$store.state.system.$.UserMessage.userName,
                            "relieveAlarmTime":new Date().getTime()
                        }
                    }
                })
                this.fvSystemApi.getAlarmData(data,(result,error) => {
                    if(error){
                        // console.log(error);
                        this.$Message.error("确认报警失败")
                    }else{
                        this.updateData();
                    }
                })
            }else{
                this.$Message.warning(this.$store.state.system.$.languageName == "ch" ?"解除报警信息不能为空！":"The unalarm message cannot be blank!")
            }
        },
        /*
            参数：无
            作用：取消确认全部报警信息
        */
        unConfirmAllAlarmMsg(){},
        /*
            参数：data 表单数据
            作用：将表单数据转化为打印形式
        */
        disposePrintData(data){
            var reg = /^[a-zA-Z]+$/;
            var rule = /[~!@#$%^&*()/\|,.<>?"'();:_+-=\[\]{}]/;
            data.forEach((item) => {
                this.alarmmReport.forEach((list) => {
                    if(list.key){
                        for(var k in item){
                            if(k == list.key){
                                item[list.title] = item[k];
                            }
                        }
                    }
                })
                for(var z in item){
                    if(reg.test(z) || rule.test(z)){
                        delete item[z];
                    }
                }
            })
        },
        /*
            参数：无
            作用：判断是否支持导出的设备
        */  
        nav(){
            var ua = navigator.userAgent,
                ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
                isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
                isAndroid = ua.match(/(Android)\s+([\d.]+)/),
                isMobile = isIphone || isAndroid;
            if(isIphone || isAndroid || isMobile){
                return true;
            }else{
                return false;
            }
        },
        /*
            参数：index 当前页数
            作用：切换分页
        */  
        changepage(index){
            if(this.temporaryData != undefined){
                this.currentPage = index;
                this.dataCount = this.temporaryData.length;
                var _start = (index - 1) * this.pageSize;
                var _end   = index * this.pageSize;
                var data = this.temporaryData.slice(_start,_end);
                this.refreshTable(data);
            }
        },

        createHead(message){
            return {
                "head" : "alarmCenter",
                    "message" : {
                        "head" : "queryWorker",
                        "message" : message
                    }
                }
        },
        /*
            参数：str 十六位制颜色 n 透明度
            作用：将十六位制的颜色转为rgba
        */
        colorRgba (str,n){
            if(!str) return;
            //十六进制颜色值的正则表达式
            var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
            var sColor = str.toLowerCase();
            //十六进制颜色转换为RGB格式  
            if(sColor && reg.test(sColor)){  
                if(sColor.length === 4){
                    var sColorNew = "#";  
                    for(var i=1; i<4; i+=1){  //例如：#eee,#fff等
                        sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));     
                    }  
                    sColor = sColorNew;  
                }  
                //处理六位颜色值  
                var sColorChange = [];  
                for(var i=1; i<7; i+=2){  
                    sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));    
                }
                return "rgba(" + sColorChange.join(",") + ","+n+")"; 
            }else{  
                return sColor;    
            }
        },
        //获取确认原因
        getHistoryCause(list){
            this.alarmDatas=[];
            var data= this.createHead({
                "head" : "getAlarmData",  
                "message" : {
                    "searchData" : {
                        "limitCount" : 10,
                        "confirmFlag":1,
                        "modelName":list.modelName,
                        "ruleName":list.ruleName
                    },
                    "alarmType" : 0
                }
            })
            this.fvSystemApi.getAlarmData(data).then((result) => {
                if(result.length == 0)return;
                for(var k in result){
                    result[k].confirmInfo.time = new Date(result[k].confirmInfo.time).format("yyyy/MM/dd hh:mm:ss")
                    this.alarmDatas.push(result[k].confirmInfo);
                }
                
            })
            .catch((error) => {
                console.log(error);
            })
        },
        showCause(){
            this.isShowHistoryCause = true;
        }
    },
    mounted(){
        this.setColor();
        setTimeout(() => {
            if(this.twinkleList.length > 0){
                this.openAudio();
            }
        }, 2000);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvAlarmCenter/fvAlarmCenter.vue